import { OutageType } from "src/types";

export const NAME = "dashboard";

export const CATEGORY_TITLE: Record<OutageType, string> = {
    [OutageType.PlannedOutage]: "outage.planned",
    [OutageType.UnplannedPartialOutage]: "outage.unplannedPartial",
    [OutageType.UnplannedOutage]: "outage.unplanned",
};
